import { render, staticRenderFns } from "./Login-2.vue?vue&type=template&id=23061568"
import script from "./Login-2.vue?vue&type=script&lang=js"
export * from "./Login-2.vue?vue&type=script&lang=js"
import style0 from "./Login-2.vue?vue&type=style&index=0&id=23061568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports